module.exports = __webpack_public_path__ + "components/home-header/static/header-7--medium@2x-fabb90ad109c4779c2853359b8ca47e1.jpg";